/**
 * Mobile card click handlers.
 */
import { beginEstimateEdit } from '../../modules/estimates';
import { openLotDetailsModal } from '../../modules/ui';
import type { TableHandlerDeps } from './types';
import { getStartElement } from './getStartElement';

export function setupCardContainerHandler(deps: TableHandlerDeps): void {
  const { els, state } = deps;

  if (!els.lotCardsContainer) return;

  els.lotCardsContainer.addEventListener(
    'click',
    (e: Event) => {
      const startEl = getStartElement(e);
      if (!startEl) return;

      const estimateButton = startEl.closest('[data-action="edit-estimate-mobile"]');
      if (estimateButton) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        const id = estimateButton.getAttribute('data-id');
        if (!id) return;

        const lot = state.lots.find((x: unknown) => (x as { id: string }).id === id);
        if (!lot) return;

        beginEstimateEdit(lot, state);
        return;
      }

      const nextBidButton = startEl.closest('.lot-card__next-bid');
      if (nextBidButton) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        const card = nextBidButton.closest('[data-id]');
        if (!card) return;

        const id = card.getAttribute('data-id');
        if (!id) return;

        const lot = state.lots.find((x: unknown) => (x as { id: string }).id === id);
        if (!lot || !lot.url) return;

        window.open(lot.url, '_blank', 'noopener,noreferrer');
        return;
      }

      const cardTarget = startEl.closest('[data-action="view-details"]');
      if (!cardTarget) return;

      const id = cardTarget.getAttribute('data-id');
      if (!id) return;

      const lot = state.lots.find((x: unknown) => (x as { id: string }).id === id);
      if (!lot) return;

      e.preventDefault();
      openLotDetailsModal(lot);
    },
    true
  );
}
